export class Company {
    companyId!: string
    libraryCardURL?: string
    shirtLogoURL?: string
    defaultUserGroupId!: string
    companyName!: string
    companyIconURL?: string
    headerIconURL?: string
    showroomRoomId?: string
    isPartnerCompany!: boolean
    isVisibleToExternalUsers?: boolean
    friendlyName!: string
    sSODomain?: string
}